import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
} from "reactstrap";
import {
  createProductType,
  getProducts,
  getProductTypes,
} from "../../../helpers/urlConfig/apiFunctions";
import {
  errorToastify,
  successToastify,
} from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import { generateUniqueId } from "../../../helpers/documentTitle";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function ProductTypeCreate({ modal_list, setmodal_list, tog_list, fetchData }) {
  const [productName, setProductName] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [productData, setProductData] = useState([
    {
      unique_stock_id: generateUniqueId(),
      product_name: "",
      product_type_name: "",
      pairs: [], // Initialize pairs array
      model_name: "",
      age: "",
      stock: 1,
      shop_name: "",
      purchase_date: "",
      created_by: getSessionData("user_id"),
      stock_type: "Incoming Stock",
    },
  ]);
  const [pairsEnabled, setPairsEnabled] = useState({});

  const handleInputChange = (index, field, value, pairIndex = null) => {
    const newProductData = [...productData];
    if (pairIndex !== null) {
      // If pairIndex is provided, update the specific pair
      newProductData[index].pairs[pairIndex][field] = value;
      newProductData[index].stock = newProductData[index].pairs.length || 1;
    } else {
      // Otherwise, update the main product data
      newProductData[index][field] = value;
    }
    setProductData(newProductData);
  };

  const addNewRow = () => {
    if (productData.length < 10) {
      setProductData([
        ...productData,
        {
          unique_stock_id: generateUniqueId(),
          product_name: "",
          product_type_name: "",
          pairs: [],
          model_name: "",
          age: "",
          shop_name: "",
          purchase_date: "",
          stock: 1,
          created_by: getSessionData("user_id"),
        },
      ]);
    }
  };

  const removeRow = (index) => {
    const newProductData = productData.filter((_, i) => i !== index);
    setProductData(newProductData);
  };

  const enablePairs = (index) => {
    setPairsEnabled((prev) => ({
      ...prev,
      [index]: true,
    }));
    // Initialize pairs array if it doesn't exist
    const newProductData = [...productData];
    if (!newProductData[index].pairs) {
      newProductData[index].pairs = [{ huid: "", gram: "" }];
    }
    setProductData(newProductData);
  };

  const addMorePairs = (index) => {
    const newProductData = [...productData];
    newProductData[index].pairs.push({ huid: "", gram: "" });
    setProductData(newProductData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // let pairStocks = [];
    // let nonPairStocks = [];

    // productData.map((item) => {
    //   if (item.pairs.length > 0) {
    //     pairStocks.push(item);
    //   } else {
    //     nonPairStocks.push(item);
    //   }
    // });

    // console.info("pairStocks", pairStocks);
    // console.info("nonPairStocks", nonPairStocks)
    const response = await createProductType(productData);

    if (response.statusCode === 400) {
      errorToastify("Duplicate Entry For Type And Model");
    }

    if (response.statusCode === 201) {
      successToastify("Stocks Created Successfully");
      fetchData();
      setmodal_list(false); // Close modal after submission
    }
  };

  const getProductData = async () => {
    try {
      const response = await getProducts();
      if (response.statusCode === 200) {
        setProductName(response.data);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const getProductTypesData = async () => {
    try {
      let response = await getProductTypes();
      let filteredResponse = response.data.filter(
        (item) => item.comments !== "Ordered"
      );

      // Ensure response.data is an array before filtering
      if (Array.isArray(filteredResponse)) {
        // Remove duplicate product_type_name
        const uniqueProductTypes = Array.from(
          new Set(filteredResponse.map((item) => item.product_type_name)).map(
            (name) =>
              filteredResponse.find((item) => item.product_type_name === name)
          )
        );

        setProductTypeList(uniqueProductTypes);
      } else {
        console.error("Invalid data format:", response.data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    getProductData();
    getProductTypesData();
  }, []);

  return (
    <Modal
      size="xl"
      isOpen={modal_list}
      toggle={tog_list}
      className="modal-fullscreen"
      id="fullscreeexampleModal"
    >
      <ModalHeader
        className="modal-title"
        id="fullscreeexampleModalLabel"
        toggle={tog_list}
      >
        Add Product Types
      </ModalHeader>
      <form className="tablelist-form" onSubmit={handleSubmit}>
        <ModalBody className="bg-light">
          {productData.map((data, index) => (
            <div
              key={index}
              className="border bg-white p-4 mb-4 rounded shadow-sm"
            >
              <h6 className="mb-3">Entry {index + 1}</h6>
              <Row className="gy-3 align-items-center">
                {/* Product Name Field */}
                <Col md={2}>
                  <label
                    htmlFor={`product_name-${index}`}
                    className="form-label"
                  >
                    Product Name
                  </label>
                  <select
                    className="form-control"
                    id={`product_name-${index}`}
                    value={data.product_name}
                    onChange={(e) =>
                      handleInputChange(index, "product_name", e.target.value)
                    }
                    required
                  >
                    <option value="">Select</option>
                    {productName.length > 0 &&
                      productName.map((item, idx) => (
                        <option key={idx} value={item.product_name}>
                          {item.product_name}
                        </option>
                      ))}
                  </select>
                </Col>

                {/* Product Type Name Field */}
                <Col md={2}>
                  <label
                    htmlFor={`product_type_name-${index}`}
                    className="form-label"
                  >
                    Product Type Name
                  </label>
                  <input
                    type="text"
                    id={`product_type_name-${index}`}
                    className="form-control"
                    placeholder="Enter Product Type Name"
                    value={data.product_type_name}
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        "product_type_name",
                        e.target.value
                      )
                    }
                    required
                    list={`productTypeSuggestions-${index}`}
                  />
                  {/* Add datalist for suggestions */}
                  <datalist id={`productTypeSuggestions-${index}`}>
                    {productTypeList.map((suggestion, i) => (
                      <option key={i} value={suggestion.product_type_name} />
                    ))}
                  </datalist>
                </Col>

                {/* Age Field */}
                <Col md={2}>
                  <label htmlFor={`huid-${index}`} className="form-label">
                    HUID
                  </label>
                  <input
                    type="text"
                    id={`huid-${index}`}
                    className="form-control"
                    placeholder="Enter HUID"
                    value={data.huid}
                    onChange={(e) =>
                      handleInputChange(index, "huid", e.target.value)
                    }
                  />
                </Col>
                {/* Age Field */}
                <Col md={2}>
                  <label htmlFor={`gram-${index}`} className="form-label">
                    Gram
                  </label>
                  <input
                    type="number"
                    id={`gram-${index}`}
                    className="form-control"
                    placeholder="Enter Gram"
                    value={data.gram || "-"}
                    onChange={(e) =>
                      handleInputChange(index, "gram", e.target.value)
                    }
                  />
                </Col>

                {/* Age Field */}
                <Col md={2}>
                  <label htmlFor={`model-${index}`} className="form-label">
                    Model Name
                  </label>
                  <input
                    type="text"
                    id={`model-${index}`}
                    className="form-control"
                    placeholder="Enter Model Name"
                    value={data.model_name}
                    onChange={(e) =>
                      handleInputChange(index, "model_name", e.target.value)
                    }
                  />
                </Col>

                {/* Age Field */}
                {/* <Col md={2}>
                  <label htmlFor={`age-${index}`} className="form-label">
                    Age
                  </label>
                  <input
                    type="number"
                    id={`age-${index}`}
                    className="form-control"
                    placeholder="Enter Age"
                    value={data.age || "-"}
                    onChange={(e) =>
                      handleInputChange(index, "age", e.target.value)
                    }
                  />
                </Col> */}
                <Col md={2}>
                  <label htmlFor={`shop_name-${index}`} className="form-label">
                    Shop Name
                  </label>
                  <input
                    type="text"
                    id={`shop_name-${index}`}
                    className="form-control"
                    placeholder="Enter Shop Name"
                    value={data.shop_name}
                    onChange={(e) =>
                      handleInputChange(index, "shop_name", e.target.value)
                    }
                  />
                </Col>

                {/* Purchase Date Field */}
                <Col md={2}>
                  <label
                    htmlFor={`purchase_date-${index}`}
                    className="form-label"
                  >
                    Purchase Date
                  </label>
                  <input
                    type="date"
                    id={`purchase_date-${index}`}
                    className="form-control"
                    value={data.purchase_date}
                    onChange={(e) =>
                      handleInputChange(index, "purchase_date", e.target.value)
                    }
                  />
                </Col>

                {/* Add Pair Button */}
                {!pairsEnabled[index] && (
                  <Col md={2}>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => enablePairs(index)}
                    >
                      Add Pair
                    </button>
                  </Col>
                )}

                {/* HUID and Gram Fields for Pairs */}
                {pairsEnabled[index] &&
                  data.pairs &&
                  data.pairs.map((pair, pairIndex) => (
                    <React.Fragment key={pairIndex}>
                      <Col md={2}>
                        <label
                          htmlFor={`huid-${index}-${pairIndex}`}
                          className="form-label"
                        >
                          HUID {pairIndex + 1}
                        </label>
                        <input
                          type="text"
                          id={`huid-${index}-${pairIndex}`}
                          className="form-control"
                          placeholder="Enter HUID"
                          value={pair.huid}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "huid",
                              e.target.value,
                              pairIndex
                            )
                          }
                          required
                        />
                      </Col>
                      <Col md={2}>
                        <label
                          htmlFor={`gram-${index}-${pairIndex}`}
                          className="form-label"
                        >
                          Gram {pairIndex + 1}
                        </label>
                        <input
                          type="text"
                          id={`gram-${index}-${pairIndex}`}
                          className="form-control"
                          placeholder="Enter Grams"
                          value={pair.gram}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "gram",
                              e.target.value,
                              pairIndex
                            )
                          }
                          required
                        />
                      </Col>
                    </React.Fragment>
                  ))}

                {/* Add More Pairs Button */}
                {pairsEnabled[index] && (
                  <Col md={2}>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => addMorePairs(index)}
                    >
                      Add More Pairs
                    </button>
                  </Col>
                )}
              </Row>

              {/* Remove Entry Button */}
              {productData.length > 1 && (
                <div className="mt-2">
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => removeRow(index)}
                  >
                    Remove Entry
                  </button>
                </div>
              )}
            </div>
          ))}

          {/* Add More Entries Button */}
          {productData.length < 10 && (
            <button
              type="button"
              className="btn btn-primary btn-sm mt-3"
              onClick={addNewRow}
            >
              Add More
            </button>
          )}
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => setmodal_list(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-success">
              Add Product Type
            </button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}

export default ProductTypeCreate;
